import { Controller } from 'stimulus';
import loadDatepicker from '@/helpers/loadDatepicker';
import formatDate from '@/helpers/formatDate';
import { format } from 'date-fns';
import createEvent from '@/helpers/createEvent';

class DatepickerController extends Controller {
  connect() {
    if (this.data.has('prices')) {
      this.prices = this.data.get('prices');
    }

    if (this.data.has('amount-of-persons')) {
      this.amountOfPersons = this.data.get('amount-of-persons');
    }

    loadDatepicker()
      .then(this.createDatePicker.bind(this));
  }

  createDatePicker() {
    const options = this.getOptions();

    options.beforeShowDay = (date) => {
      if (this.data.has('prices')) {
        return this.addPricesToDays(date);
      }

      return {};
    };

    $(this.element).datepicker(options);

    if (this.hasInputTarget) {
      $(this.element).datepicker().on('changeDate', () => {
        createEvent(this.inputTarget);
        this.triggerBookingFormActions.call(this);
      });
    }

    if (this.data.has('for-filter') && this.data.get('for-filter')) {
      $(this.element).datepicker().on('changeDate', (e) => {
        this.inputTarget.value = format(e.date, 'yyyy-MM-dd');
        this.inputTarget.dataset.label = `${this.inputTarget.dataset.label}: ${format(e.date, 'dd-MM-yyyy')}`;

        this.triggerFilter();
      });
    }

    this.triggerBookingFormActions();
  }

  updateDatePicker() {
    $(this.element).datepicker('update');
  }

  addPricesToDays(date) {
    if (typeof this.prices === 'undefined' || this.prices === '') return {};

    const parsedPrices = JSON.parse(this.prices);
    const key = formatDate(date);
    const price = typeof parsedPrices[key] !== 'undefined' ? parsedPrices[key] : '';
    const priceForAmountOfPersons = typeof price[this.amountOfPersons] !== 'undefined'
      ? price[this.amountOfPersons]
      : '';

    return {
      classes: priceForAmountOfPersons === '' ? 'disabled' : '',
      content: `
        ${date.getDate()}
        <span class="price">${priceForAmountOfPersons}</span>
      `,
    };
  }

  getOptions() {
    return {
      language: 'nl',
      autoclose: true,
      datesDisabled: this.getOptionOrDefault('disabled-dates', []),
      daysOfWeekDisabled: this.getOptionOrDefault('disabled-days-of-week', []),
      defaultViewDate: this.getOptionOrDefault('default-view-date', 'today'),
      startView: this.getOptionOrDefault('start-view', 0),
      startDate: this.getOptionOrDefault('start-date', -Infinity),
      orientation: this.getOptionOrDefault('orientation', 'bottom left'),
    };
  }

  getOptionOrDefault(key, defaultValue) {
    return this.data.has(key)
      ? this.data.get(key)
      : defaultValue;
  }

  triggerFilter() {
    const filterControllerEl = document.querySelector('[data-controller*="filter"]');
    const filterController = this.application.getControllerForElementAndIdentifier(filterControllerEl, 'filter');

    filterController.onFilterChange();
  }

  triggerBookingFormActions() {
    const bookingFormControllerEl = document.querySelector('[data-controller*="sidebar-booking-form"]');
    const bookingFormController = this.application.getControllerForElementAndIdentifier(bookingFormControllerEl, 'sidebar-booking-form');

    if (!this.hasInputTarget || !bookingFormController) return;

    const $selectedDate = $(this.element).find('.active.day');
    const $price = $selectedDate.find('.price');

    if (this.inputTarget.value === '' || $price.html() === '') {
      bookingFormController.toggleNotification(false);
      bookingFormController.disableSubmitButton();
      return;
    }

    bookingFormController.toggleNotification(true);
    bookingFormController.enableSubmitButton();
  }
}

DatepickerController.targets = [
  'input',
];

export default DatepickerController;
